import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FieldProps, Input } from '../Input';
import styles from './Table.module.css';

type Props<TFormState extends BaseFormState> = Omit<FieldProps<TFormState>, 'type' | 'className'>;

function SearchElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLInputElement>
) {
  return <Input.Field type="search" ref={ref} className={styles.search} {...props} />;
}

export const Search = forwardRef(SearchElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReturnType<typeof SearchElement>;
